import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  HandlersUserDetailResponse,
  useGetApiUsersQuery,
} from '../../../../../app/athenaApiGen';
import { RootState } from '../../../../../app/store';

type TUserAutoCompleteProps = {
  onChange: (newContant?: string) => void;
};

const UsersAutocomplete = (props: TUserAutoCompleteProps) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [options, setOptions] = useState<HandlersUserDetailResponse[]>([]);
  const uploadPayload = useSelector(
    (state: RootState) => state.library.uploadPayload,
  );
  const { data, isFetching: isLoading } = useGetApiUsersQuery();

  const handleOpen = () => {
    setOpen(true);
    setOptions(data ?? []);
  };

  const handleClose = () => {
    setOpen(false);
    setOptions([]);
  };
  return (
    <Autocomplete
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      isOptionEqualToValue={(option, value) =>
        option.userName === value.userName
      }
      getOptionLabel={(option) => option.userName ?? ''}
      // Key each option by the unique user id. Without this, MUI's default
      // renderOption keys by the label (userName), which collides when two
      // contacts share a name (e.g. two "Kevin Suber" records) and triggers a
      // React duplicate-key warning.
      renderOption={(optionProps, option) => {
        const { key: _key, ...rest } = optionProps;
        return (
          <li {...rest} key={option.id ?? option.contact?.contactId}>
            {option.userName}
          </li>
        );
      }}
      options={options}
      loading={isLoading}
      onChange={(_, newValue) => props.onChange(newValue?.contact?.contactId)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Owner"
          size="small"
          required
          value={uploadPayload?.creatorContactId || null}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isLoading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            },
          }}
        />
      )}
    />
  );
};

export { UsersAutocomplete };
